import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { TableFilterSection } from '../../styles/BasicStyles';
import TextInput from '../../components/generic/inputs/TextInput';
import SelectInput from '../../components/generic/inputs/SelectInput';
import { Departments } from '../../infra/services/utils/Departments';

class ContributorsFilters extends Component {
  state = {
    search: '',
    department: ''
  };

  onInputChange = (field, value, timeout = 0) => {
    this.setState({ [field]: value }, () => {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(this.constructQuery, timeout);
    });
  };

  constructQuery = () => {
    const { queryChange } = this.props;
    const query = {};
    Object.keys(this.state).map((key) => {
      if (this.state[key] && this.state[key] !== '') {
        query[key] = this.state[key];
      }
      return key;
    });
    queryChange(JSON.stringify(query));
  };

  render() {
    const { search, department } = this.state;
    return (
      <TableFilterSection>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <TextInput
              input={{
                value: search,
                onChange: (event) =>
                  this.onInputChange('search', event.target.value, 1000)
              }}
              meta={{ valid: true }}
              type="text"
              label="Pesquisar"
              placeholder="Procurar por código, nome, email ou pelo contacto"
            />
          </Col>
          <Col xs={24} md={5}>
            <SelectInput
              label="Departamento"
              allowClear
              placeholder="Procurar por departamento..."
              data={Departments}
              meta={{ valid: true }}
              input={{
                value: department,
                onChange: (value) => this.onInputChange('department', value)
              }}
            />
          </Col>
        </Row>
      </TableFilterSection>
    );
  }
}

export default ContributorsFilters;
